import firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/database';

import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Footer from './components/FooterPage';
import { ensureDatabaseAuth } from './databaseAuth';

// Code-splitting: mỗi trang là 1 chunk riêng, chỉ tải khi điều hướng tới.
// Nhờ vậy bundle ban đầu (trang landing) không phải tải Const.js/convert.js/xlsx của các trang nặng.
const Home = lazy(() => import('./pages/Home'));
const SearchPage = lazy(() => import('./pages/SearchPage'));
const Main = lazy(() => import('./pages/HomePage'));
export default function BasicExample() {
  var database = {
    apiKey: 'AIzaSyAqDXUKgULXkPDQIs2Le_beT6R0_JcmyY8',
    authDomain: 'tmfs-yi-jing.firebaseapp.com',
    databaseURL: 'https://tmfs-yi-jing.firebaseio.com',
    projectId: 'tmfs-yi-jing',
    storageBucket: 'tmfs-yi-jing.appspot.com',
    messagingSenderId: '331042421722',
    appId: '1:331042421722:web:862f72fc6b6c3ed5419ee3',
  };

  const firebaseConfig = {
    apiKey: 'AIzaSyA9A_F8LJdj8OiVsSNQqmly3xFXVwJulxw',
    authDomain: 'ky-mon.firebaseapp.com',
    databaseURL: 'https://ky-mon.firebaseio.com',
    projectId: 'ky-mon',
    storageBucket: 'ky-mon.appspot.com',
    messagingSenderId: '135312632635',
    appId: '1:135312632635:web:4c555b879296f6bc59a51e',
  };

  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }
  if (!firebase.apps.find((app) => app.name === 'database')) {
    firebase.initializeApp(database, 'database');
  }
  // Khởi động xác thực tài khoản dịch vụ (không chặn render). Logic dùng chung
  // ở databaseAuth.js để các trang có thể `await` trước khi đọc Firestore.
  ensureDatabaseAuth().catch(() => {});
  return (
    <Router>
      <Suspense fallback={<div style={{ textAlign: 'center', padding: '40px' }}>Đang tải...</div>}>
        <Switch>
          <Route exact path="/" component={Main} />

          {/* <Home /> */}
          {/* </Route> */}
          {/* <Route exact path="/SearchKyMonDonGiapHour" component={SearchKyMonDonGiap} /> */}
          {/* <Route exact path="/SearchQuai" component={SearchQuai} /> */}
          <Route exact path="/TrachNhat" component={Home} />

          {/* <LaBanFullSize /> */}
          {/* <Route exact path="/NewHomeUI" component={TestKyMonDonGiap} /> */}
          {/* </Route> */}
          <Route exact path="/SearchPage" component={SearchPage} />
          {/* <TestKyMonDonGiap /> */}
          {/* </Route> */}
        </Switch>
      </Suspense>
      <Footer></Footer>
    </Router>
  );
}
